import { render, staticRenderFns } from "./PageOne.vue?vue&type=template&id=aaf4c2bc&scoped=true"
import script from "./PageOne.vue?vue&type=script&lang=js"
export * from "./PageOne.vue?vue&type=script&lang=js"
import style0 from "./PageOne.vue?vue&type=style&index=0&id=aaf4c2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf4c2bc",
  null
  
)

export default component.exports